import React from "react";
import { WMSTileLayer } from "react-leaflet";

const normalizeArcGISWmsUrl = (url) => {
  if (!url) return url;
  const lower = url.toLowerCase();
  if (lower.includes("wmsserver")) return url; // ya es WMS

  const mapServerRegex = /\/rest\/services\/.+\/mapserver\/?$/i;
  if (mapServerRegex.test(lower)) {
    const trimmed = url.replace(/\/+$/, "");
    return `${trimmed}/WMSServer`;
  }

  return url;
};

const ArcGISWMSLayer = ({
  url,
  layers,
  format = "image/png",
  transparent = true,
  version = "1.1.1",
  styles = "",
  tileSize = 256,
  opacity = 1,
  zIndex,
  attribution,
  ...rest
}) => {
  const wmsUrl = normalizeArcGISWmsUrl(url);

  if (!wmsUrl || !layers) return null;

  return (
    <WMSTileLayer
      url={wmsUrl}
      layers={layers}
      format={format}
      transparent={transparent}
      version={version}
      styles={styles}
      tileSize={tileSize}
      opacity={opacity}
      zIndex={zIndex}
      attribution={attribution}
      {...rest}
    />
  );
};

export default ArcGISWMSLayer;

